import { reservationAxios } from '../../../core/rest/axios';
export async function loadGroupList(branchId) {
    return reservationAxios.get('/skupinycinnosti', { params: { pobockaId: branchId } })
        .then((response) => response.data);
}
